import { createSelector } from 'reselect';

import { createKeySelector } from 'Lib/reduxUtils';

export const selectWebProfile = createKeySelector('webProfile');

export const getUsername = createSelector(selectWebProfile, (webProfile) => webProfile.username);

export const getUser = createSelector(selectWebProfile, (webProfile) => webProfile.user);

export const getUserID = createSelector(getUser, (user) => user?._id);

export const getDeeplink = createSelector(selectWebProfile, (webProfile) => webProfile.deeplink);
